import { Download } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, scrollToEl } from "../lib/anim";

export const Footer = ({ onDownload }) => {
  return (
    <footer data-testid="footer-section" className="relative bg-[#050d1a]">
      {/* Closing CTA card */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-[#112240] px-8 py-16 md:px-16 md:py-24 text-center">
            <div className="absolute inset-0 gx-grid-bg opacity-40" />
            <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-64 w-[80%] rounded-full bg-[#4CAF50]/15 blur-[100px]" />
            <div className="relative">
              <h2 className="font-display font-black text-3xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl mx-auto">
                Ready to turn your unused data into{" "}
                <span className="gx-text-gradient">monthly petrol money?</span>
              </h2>
              <p className="mt-6 text-slate-300 max-w-xl mx-auto">
                Join the DePIN network built for Indian roads. 100% Fiat INR.
                Zero crypto headaches.
              </p>
              <button
                data-testid="footer-download-btn"
                onClick={onDownload}
                className="group mt-10 inline-flex items-center gap-2.5 rounded-full bg-[#4CAF50] px-9 py-4.5 py-4 text-base font-semibold text-[#04140a] hover:brightness-110 transition-[filter,transform] duration-200 hover:-translate-y-0.5 gx-green-glow"
              >
                <Download size={20} className="transition-transform duration-200 group-hover:translate-y-0.5" />
                Download for Android
              </button>
              <p className="mt-4 text-xs text-slate-500 font-mono-gx uppercase tracking-widest">
                Coming soon on Google Play
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src="/geonetix-logo-full.webp" alt="GeoNetix" className="h-11 w-auto object-contain" />
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm text-slate-400">
            <button onClick={() => scrollToEl("#dual-engine")} className="hover:text-[#00B4D8] transition-colors duration-200">Dual-Engine</button>
            <button onClick={() => scrollToEl("#buy-dvr")} className="hover:text-[#00B4D8] transition-colors duration-200">Buy Car DVR</button>
            <button onClick={() => scrollToEl("#calculator")} className="hover:text-[#00B4D8] transition-colors duration-200">Calculator</button>
            <button onClick={() => scrollToEl("#how-it-works")} className="hover:text-[#00B4D8] transition-colors duration-200">How It Works</button>
            <button onClick={() => scrollToEl("#faq")} className="hover:text-[#00B4D8] transition-colors duration-200">FAQ</button>
            <Link to="/contact" data-testid="footer-contact-link" className="hover:text-[#00B4D8] transition-colors duration-200">Contact Us</Link>
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-[#00B4D8] transition-colors duration-200">Privacy Policy</Link>
            <Link to="/data-deletion" data-testid="footer-data-deletion-link" className="hover:text-[#00B4D8] transition-colors duration-200">Request Data Deletion</Link>
          </div>
          <div className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} GeoNetix. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};
